import { CanDeactivate } from '@angular/router';
import { Injectable,TemplateRef,ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfirmationPopupComponent } from 'src/app/shared/confirmation-popup/confirmation-popup.component';
import { PmdModal,PmdModalService,PmdModalRef } from 'src/app/shared/propeller';


export interface ComponentCanDeactivate {
  //canDeactivate: () => boolean | Observable<boolean>;
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({providedIn: 'root'})
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
  modalRef: PmdModalRef;  
  constructor(private modalService: PmdModalService) { }  

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    // if there are no pending changes, just allow deactivation; else confirm first
    return component.canDeactivate() ?
      true :
      // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
      // when navigating away from your angular app, the browser will show a generic warning message
      // see http://stackoverflow.com/a/42207299/7307355
      this.showPopup();
  }


  /**
   * show the popup
   */
  showPopup():Observable<boolean> {
    const modalRef: PmdModalRef = this.modalService.show(ConfirmationPopupComponent,Object.assign({}, { class: 'modal-dialog modal-dialog-centered modal-sm' }));
    return new Observable<boolean>((observer) => {
      modalRef.content.confirmed.subscribe((confirmation: boolean) => {
       observer.next(confirmation);
       observer.complete();
       console.log(confirmation);
        modalRef.hide();
      });
    });
    
  }
}